import { AxiosInstance } from 'axios';
import { IItem } from 'src/views/Admin/Items/types';
import { insertId } from '../../insertId';
import { toResponse } from '../../genericToResponse';

export default (api: AxiosInstance, url: string) => async (id: number) => {
  const urlWithId = insertId(url, id);
  const response = await api.delete(urlWithId);
  return toResponse(response.data) as IItem[];
};



// WEBPACK FOOTER //
// ./src/services/api/admin/items/remove.ts